// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CostReviewStatus {
  None = 0,
  Pending = 1,
  Approved = 2,
  Denied = 3,
  NotStarted = 4,
  InProcess = 5,
}
